import createIcon from '../../createIcon';

/**
 * @component @name ViewComfyAlt
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgNEg0QzIuOSA0IDIgNC45IDIgNlYxOEMyIDE5LjEgMi45IDIwIDQgMjBIMjBDMjEuMSAyMCAyMiAxOS4xIDIyIDE4VjZDMjIgNC45IDIxLjEgNCAyMCA0Wk0xMSAxN0g3VjEzSDExVjE3Wk0xMSAxMUg3VjdIMTFWMTFaTTE3IDE3SDEzVjEzSDE3VjE3Wk0xNyAxMUgxM1Y3SDE3VjExWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ViewComfyAlt = createIcon('ViewComfyAlt', [
  [
    'path',
    {
      d: 'M20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM11 17H7V13H11V17ZM11 11H7V7H11V11ZM17 17H13V13H17V17ZM17 11H13V7H17V11Z',
      key: 'o7qaxt',
    },
  ],
]);

export default ViewComfyAlt;
